exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ar-volume {\n  display: flex;\n  align-items: center;\n  line-height: 10px;\n}\n.ar-volume-bar {\n    width: 50px;\n    height: 6px;\n    background: #E6E6E6;\n    border-radius: 4px;\n    position: relative;\n}\n.ar-volume__icon {\n    fill: #747474;\n    width: 24px;\n    height: 24px;\n    border: 0;\n    border-radius: 0;\n    padding: 0;\n    background-color: unset;\n    margin-right: 3px;\n}\n", ""]);

// exports
